import React from "react";

export default function AppointmentIcon({ className }) {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_303_3027)">
          <path
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
          <path
            d="M8 8.75C8.41421 8.75 8.75 8.41421 8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75Z"
            fill="currentColor"
          />
          <path
            d="M10.75 8.75C11.1642 8.75 11.5 8.41421 11.5 8C11.5 7.58579 11.1642 7.25 10.75 7.25C10.3358 7.25 10 7.58579 10 8C10 8.41421 10.3358 8.75 10.75 8.75Z"
            fill="currentColor"
          />
          <path
            d="M5.25 8.75C5.66421 8.75 6 8.41421 6 8C6 7.58579 5.66421 7.25 5.25 7.25C4.83579 7.25 4.5 7.58579 4.5 8C4.5 8.41421 4.83579 8.75 5.25 8.75Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_303_3027">
            <rect width="16" height="16" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
